import * as React from 'react'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { Action } from 'redux'
import { setSort } from 'actions/filters'
import { ISortModel } from 'reducers/filters/models'
import { saveCostAndRevenue, fetchJobStatus, fetchRevenueData, fetchCostData, deleteChargeItemCBL } from 'actions/costRevenue'
import { IStore } from 'reducers/index'
import CostColumnsData from '../../../views/job-costing/utils/CostColumnsData'
import { InPageDialog } from 'damco-components'
import { HandleError } from 'components/handle-error'
import { INickname } from 'reducers/nickname'
import { haveLoginData, convertNumbers, FinOpsStatusPermission }
    from '../../../views/job-costing/utils/CostAndRevenueHelpers'
import { UserDataControl } from 'components/cost-revenue/UserDataControl'
import { ItemCategoryCheck } from 'modules/cost-revenue/component/ItemCategoryCheck'
import { CostRevNewEmptyData, CostRevSplitEmptyData, EmptyQuantityDistribution } from 'constants/costRevenue'
import { formatValueIfNullOrUndefined, isFeatureEnabled } from 'utilities/util'
import * as validationConstants from 'constants/validationMessages'
import { status_text } from 'components/exception-management/constants'
import { IFeatureToggleModel } from 'reducers/featureToggle/models'
import { FEATURE_TOGGLES } from 'constants/featureToggles'
import { AddEditDialogNew } from '../dialog/AddEditDialogNew'
import { ModalMain } from 'damco-components'
import { CostAndRevenueTablesWrapNew } from './CostAndRevenueTablesWrapNew'
import { ICostorRevenue, IResponseCostorRevenue } from 'reducers/bookings/models'
import { IChargeItem, IChargeItemExtraFields, ICostRevenue, IEditCostRevenue, IEquipments, IExportJob, ISaveCostRevenue } from 'reducers/cbl/models'
import ExportJobDetailsTable from './ExportJobDetailsTable'
import { ModalScreen } from 'components/modal-screen';
import { ModalType } from 'components/modal-screen/ModalType';
import { SUCCESS_MESSAGE } from 'constants/messages';
import { BLOCKED_TYPES } from 'constants/blockedTypes'

interface IParams {
    costAndRevenueId: number;
    fStatus: string[];
    readOnly: boolean;
    isRevButtonHidden?: boolean;
    partyData: any;
    targetId: number;
    docId: number | string;
    showInvoices: boolean;
    invoicesData?: any;
    distributionData?: any;
    targetType: string; // 'origin' | 'destination';
    outputCostRev: (cost: any[], revenue: any[]) => void;
    navigateTo?: (url: string) => void;
    toggleTabs: (b: boolean) => void;
    eventCallback: () => void;
    getCurrentPageMode?: (mode: string) => void;
    costResponseData: IResponseCostorRevenue;
    revenueResponseData: IResponseCostorRevenue;
    isSourceAthena: boolean;
    isNftpBillable: boolean | undefined;
    isNftpRoeEnabled: boolean | undefined;
}
interface IMapDispatchToProps {
    saveCostAndRevenue: (data: any, targetType: string, target: string, isEdit?: boolean) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    fetchJobStatus: (valueId: number) => Promise<void>;
    fetchRevenueData: (id: number, page?: number, pageSize?: number) => Promise<void>;
    fetchCostData: (id: number, page?: number, pageSize?: number) => Promise<void>;
    deleteChargeItemCBL: (chargeItems: any, type: string, id: number) => Promise<void>;
}
interface IMapStateToProps {
    isFetchDataLoading: boolean;
    isFetchDataError: boolean;
    pendingError: string | string[],
    feedbackResponse: any;
    nickname: INickname;
    featureToggles: IFeatureToggleModel[];
    validateJobStatus: boolean;
    costResponse: IResponseCostorRevenue;
    revenueResponse: IResponseCostorRevenue;
}

interface IProps extends IParams, IMapStateToProps, IMapDispatchToProps { }

interface IState {
    hasZero: boolean;
    fetchInProgress: boolean;
    errorMsg: string | string[];
    cost: any[];
    data: any[];
    revenue: any[];
    isCostEditMode: boolean;
    isRevenueEditMode: boolean;
    showDialog: boolean;
    showErrorModal: boolean;
    showAddRevCostErrorModal: boolean;
    showExportJobsModal: boolean;
    validationError: any;
    showModal: boolean;
    dialogData: {
        data: IChargeItem[],
        type: string,
        target: string,
        targetFunctionality: number,
        dependencies: any[],
        vendorsData: any[],
        readonlyState: boolean,
    };
    footerUpdate: boolean;
    pendingConfirmation: boolean;
    revCostErrorModalMsg: string;
    revenueResponse: IResponseCostorRevenue;
    costResponse: IResponseCostorRevenue;
    currentIndex: number;
    chargeType: string;
    isAddEditDialogExited: boolean;
}
export class _CostAndRevenueNew extends React.Component<IProps, IState> {

    private chargeItemCostOrRevenue: ICostorRevenue;

    constructor(props: any) {
        super(props)
        this.state = {
            hasZero: false,
            fetchInProgress: true,
            footerUpdate: false,
            errorMsg: '',
            cost: [],
            data: [],
            revenue: [],
            isCostEditMode: false,
            isRevenueEditMode: false,
            validationError: {
                target: '',
                message: '',
                keys: []
            },
            showDialog: false,
            showErrorModal: false,
            showAddRevCostErrorModal: false,
            showExportJobsModal: false,
            revCostErrorModalMsg: '',
            showModal: false,
            dialogData: {
                data: [],
                type: '',
                target: '',
                targetFunctionality: -1,
                dependencies: [],
                vendorsData: [],
                readonlyState: false,
            },
            pendingConfirmation: false,
            revenueResponse: {
                totalCount: 0,
                page: 1,
                pageSize: 10,
                data: []
            },
            costResponse: {
                totalCount: 0,
                page: 1,
                pageSize: 10,
                data: []
            },
            currentIndex: -1,
            chargeType: '',
            isAddEditDialogExited: true
        }
    }
    public componentDidMount = () => {
        this.props.fetchJobStatus(Number(this.props.costAndRevenueId))
        if (this.props.revenueResponseData.data.length > 0 || this.props.costResponseData.data.length > 0) {
            this.setState({
                revenueResponse: this.props.revenueResponseData,
                costResponse: this.props.costResponseData,
                currentIndex: 0,
            })
            setTimeout(() => { this.splitData() }, 50)
        }
    }
    public componentDidUpdate = (prevProps: any, prevState: any) => {
        if (this.props.revenueResponse.data !== prevProps.revenueResponse.data || this.props.costResponse.data !== prevProps.costResponse.data) {
            this.setState({
                showDialog: false,
                errorMsg: '',
                revenueResponse: this.props.revenueResponse,
                costResponse: this.props.costResponse,
                currentIndex: 0,
                isAddEditDialogExited: true
            }, () => {
                this.splitData()
            })
        }
        if (this.props.pendingError !== prevProps.pendingError) {
            let checkText = this.props.pendingError
            if ((Array.isArray(this.props.pendingError) && this.props.pendingError.length === 0) ||
                this.props.pendingError === '') {
                checkText = validationConstants.CostAndRevenue.Error_Add_charges
            }
            this.setState({
                showDialog: true,
                footerUpdate: true,
                errorMsg: checkText
            })
        }
        if (this.props.feedbackResponse && this.props.feedbackResponse !== prevProps.feedbackResponse) {
            if (this.props.feedbackResponse === SUCCESS_MESSAGE) {
                this.setState({
                    pendingConfirmation: false,
                    footerUpdate: true,
                })
                this.props.fetchRevenueData(Number(this.props.costAndRevenueId), 1, 10)
                this.props.fetchCostData(Number(this.props.costAndRevenueId), 1, 10)
                this.setState({
                    revenueResponse: this.props.revenueResponse,
                    costResponse: this.props.costResponse,
                })
            } else {
                this.setState({
                    showDialog: true,
                    footerUpdate: true,
                    errorMsg: this.props.feedbackResponse
                })
            }
        }
        if (this.state.showDialog !== prevState.showDialog && this.state.showDialog) {
            window.scroll(0, 0)
        }
    }
    public getType = () => {
        switch (this.props.targetId) {
            case 2:
                return 'equipment'
                break
            case 3:
                return 'cbl'
                break
            case 4:
                return 'fcr'
                break
            case 5:
                return 'ets'
                break
        }
        return 'booking'
    }
    public render() {
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles)
        return (
            <React.Fragment>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.errorMsg}
                    closeMethod={() => this.setState({ showDialog: false, errorMsg: '' })} />
                <HandleError
                    error={this.props.pendingError}
                />
                {this.state.showModal &&
                    <AddEditDialogNew
                        isDestination={this.props.targetType === 'destination' ? true : false}
                        {...this.state.dialogData}
                        shouldDisplay={this.state.showModal}
                        onSave={(data: any | null, target: string, shouldCleanStore: boolean) => this.consolidateDialogData(data, target, shouldCleanStore)}
                        onClose={(target: string) => { this.closeModal(target); this.props.toggleTabs(false); this.splitData() }}
                        partyData={this.props.partyData}
                        costAndRevenueId={this.props.costAndRevenueId}
                        isSourceAthena={this.props.isSourceAthena}
                    />}
                {!this.state.showModal && <div>
                    <ItemCategoryCheck
                        displayDialog={this.state.showErrorModal}
                        message={FinOpsStatusPermission(this.props.fStatus, null) ? validationConstants.CostAndRevenue.Alert_Charge_locked : validationConstants.CostAndRevenue.Alert_Status_Charge_locked}
                        closeDialog={() => { this.setState({ showErrorModal: false }) }} />
                    {this.state.showAddRevCostErrorModal && <ModalMain
                        modal={this.state.showAddRevCostErrorModal}
                        title={'Finops Add Charge'}
                        hideMethod={() => this.setState({ showAddRevCostErrorModal: false })}
                        secondaryMethod={() => this.setState({ showAddRevCostErrorModal: false })}
                        primaryMethod={() => this.setState({ showAddRevCostErrorModal: false })}
                        btnTitle2={'CLOSE'}
                        btnTitle1={'OK'}>
                        <pre>{this.state.revCostErrorModalMsg}</pre>
                    </ModalMain>}
                    {this.state.showExportJobsModal && <ModalScreen
                        id={'exportjobs-new-modal'}
                        title=""
                        visible={true}
                        modalType={ModalType.customCbl()}
                        closeModal={() => this.setState({ showExportJobsModal: false })}
                        hideSecondaryButton={true}
                        secondaryButtonTitle="Cancel"
                        secondaryButtonFunc={() => this.setState({ showExportJobsModal: false })}
                        primaryButtonTitle="Ok"
                        primaryButtonFunc={() => this.setState({ showExportJobsModal: false })}>
                        <div className="dataTableWrapper">
                            <ExportJobDetailsTable
                                id="exportJobId"
                                chargeItem={this.chargeItemCostOrRevenue}
                                setCurrentIndex={this.onTargetClick}
                                index={this.state.currentIndex}
                                cblId={this.props.costAndRevenueId}
                                target={this.state.chargeType}
                            />
                        </div>
                    </ModalScreen>}
                    <UserDataControl
                        nickname={this.props.nickname}
                    />
                    {this.props.targetId && <CostAndRevenueTablesWrapNew
                        funcId={this.getType()}
                        forceFooterUpdate={this.state.footerUpdate}
                        finOpsStatus={this.props.fStatus}
                        readOnly={this.props.readOnly}
                        isFetchLoading={this.props.isFetchDataLoading}
                        fetchData={this.targetFetch}
                        addAction={this.tablePrimaryAction}
                        isRevButtonHidden={this.props.isRevButtonHidden}
                        editAction={this.tableEdit}
                        deleteAction={this.deleteRevenue}
                        linkAction={this.openExportjobModal}
                        isExtraDocumentFeatureEnabled={isExtraDocumentFeatureEnabled}
                        costResponse={this.state.costResponse}
                        revenueResponse={this.state.revenueResponse}
                        cblId={this.props.costAndRevenueId}
                        isNftpBillable={this.props.isNftpBillable}
                        isNftpRoeEnabled={this.props.isNftpRoeEnabled}
                    />}
                </div>}
            </React.Fragment>
        )
    }

    public openExportjobModal = (item: ICostorRevenue, target: string) => {
        this.setState({
            showExportJobsModal: true,
            chargeType: target
        })
        this.chargeItemCostOrRevenue = item
    }

    public onTargetClick = (index: number) => {
        this.setState({
            currentIndex: index
        })
    }

    private targetFetch = (target: string, page: number, pageSize: number) => {
        if (this.state.isAddEditDialogExited) {
            if (target === CostColumnsData.TYPES.COST) {
                const newPage = this.props.costResponse.totalCount < pageSize ? 1 : page
                this.props.fetchCostData(Number(this.props.costAndRevenueId), newPage, pageSize)
            } else {
                const newPage = this.props.revenueResponse.totalCount < pageSize ? 1 : page
                this.props.fetchRevenueData(Number(this.props.costAndRevenueId), newPage, pageSize)
            }
        }
    }

    private splitData = () => {
        if (this.state.revenueResponse.data.length === 0 && this.state.costResponse.data.length === 0) {
            return
        }
        const costs: any = []
        const revenues: any = []
        const getHTML = (text: string) => {
            return <span dangerouslySetInnerHTML={{ __html: `${status_text.negative} ${text}` }} />
        }
        if (this.state.revenueResponse.data.length > 0) {
            this.state.revenueResponse.data.map((element: any, index: number) => {
                element.specialPricingCondition = element.specialPricingCondition === 'Y' || element.specialPricingCondition === true ? 'Y' : 'N';
                if (element.materialCode) {
                    element.chargeItem = element.materialCode
                }
                element.chargeItem = element.errorReason && element.errorReason.length > 0 ? getHTML(element.chargeItem) : element.chargeItem
                element.icbIndicator = formatValueIfNullOrUndefined(element.icbIndicator);
                element.blockedType = element.blockedType !== BLOCKED_TYPES.UNBLOCK ? element.blockedType : '';
                convertNumbers(element)
                element.viewType = element.viewType.toUpperCase()
                element.children = []
                revenues.push(element)
            })
        }

        if (this.state.costResponse.data.length > 0) {
            this.state.costResponse.data.map((element: any, index: number) => {
                element.specialPricingCondition = element.specialPricingCondition === 'Y' || element.specialPricingCondition === true ? 'Y' : 'N';
                if (element.materialCode) {
                    element.chargeItem = element.materialCode
                }
                element.chargeItem = element.errorReason && element.errorReason.length > 0 ? getHTML(element.chargeItem) : element.chargeItem
                element.icbIndicator = formatValueIfNullOrUndefined(element.icbIndicator)
                convertNumbers(element)
                element.viewType = element.viewType.toUpperCase()
                element.children = []
                costs.push(element)
            })
        }

        this.props.outputCostRev(costs, revenues)
        const revZero: any[] = revenues.filter((item: any) => {
            return Number(item.quantity) <= 0 || Number(item.rate) <= 0
        })
        this.setState({
            hasZero: revZero.length > 0,
            data: [...revenues, ...costs],
            cost: [...costs],
            revenue: [...revenues],
            fetchInProgress: false,
        })
    }
    private consolidateDialogData = (data: any | null, target: string, shouldCleanStore: boolean) => {
        if (data) {
            this.saveRevenue(data, target, shouldCleanStore)
            this.setState({
                showModal: false
            })
        } else {
            this.closeModal(target)
        }
        this.props.toggleTabs(false)
        this.passCurrentMode('')
    }
    private closeModal = (e: string) => {
        let isEdit: any = { isRevenueEditMode: false }
        if (e === CostColumnsData.TYPES.COST) {
            isEdit = { isCostEditMode: false }
        }
        this.setState({
            ...isEdit,
            showModal: false,
            showAddRevCostErrorModal: false,
            revCostErrorModalMsg: '',
            dialogData: {
                data: [],
                vendorsData: [],
                type: '',
                target: '',
                targetFunctionality: -1,
                dependencies: []
            }
        })
        this.passCurrentMode('')
    }

    private passCurrentMode = (mode: string) => {
        if (this.props.getCurrentPageMode) {
            this.props.getCurrentPageMode(mode)
        }
    }

    private tablePrimaryAction = (e: any, target: string) => {
        const msgCatagory = target === 'REV' ? 'Revenue' : 'Cost'
        this.setState({ revCostErrorModalMsg: `The FinOps status is in requested state, adding new ${msgCatagory} not possible.` })
        if (!this.props.validateJobStatus) {
            const emtpyData = JSON.parse(JSON.stringify(CostRevNewEmptyData))
            emtpyData.essoRateDistributions = []
            if (haveLoginData(this.props.nickname)) {
                emtpyData.localCurrency = CostColumnsData.GetLocalCurrency(this.props.partyData.country)
                emtpyData.condCurrency = emtpyData.localCurrency
                emtpyData.itemType = this.props.nickname.employeeId
                const lastId = this.state.data.length === 0 ? 1 : this.state.data.slice(-1)[0].id
                emtpyData.id = lastId + 1
                let vendorsData: any[] = []
                if (target === CostColumnsData.TYPES.COST) {
                    this.setState({
                        isCostEditMode: true
                    })
                } else {
                    vendorsData = [
                        this.props.targetId,
                        this.props.costAndRevenueId
                    ]
                    this.setState({
                        isRevenueEditMode: true
                    })
                }
                this.props.toggleTabs(true)
                this.setState({
                    showModal: true,
                    footerUpdate: false,
                    dialogData: {
                        target,
                        vendorsData,
                        data: [{ ...emtpyData }],
                        readonlyState: false,
                        type: 'add',
                        targetFunctionality: this.props.targetId,
                        dependencies: []
                    }
                })
                this.passCurrentMode('add')
            }
        } else {
            this.setState({ showAddRevCostErrorModal: true })
        }
    }

    private tableEdit = (e: any, typeOfEdit: string) => {
        const data = [...e]
        let target: any = { isCostEditMode: true }
        let vendorsData: any[] = []
        if (typeOfEdit === CostColumnsData.TYPES.REVENUE) {
            target = { isRevenueEditMode: true }
            vendorsData = [
                this.props.targetId,
                this.props.costAndRevenueId
            ]
        }
        if (haveLoginData(this.props.nickname)) {
            this.props.toggleTabs(true)
            this.setState({
                ...target,
                pendingError: '',
                footerUpdate: false,
                showErrorModal: false,
                showAddRevCostErrorModal: false,
                showExportJobsModal: false,
                revCostErrorModalMsg: '',
                showDialog: false,
                showModal: true,
                dialogData: {
                    vendorsData,
                    data: this.populateDataForEdit(data),
                    type: 'edit',
                    readonlyState: false,
                    target: typeOfEdit,
                    targetFunctionality: this.props.targetId,
                    dependencies: []
                }
            })
            this.passCurrentMode('edit')
        }
    }

    private deleteRevenue = (e: any, reason: string, target: string) => {
        const elDelete: any = {}
        elDelete.viewType = e[0].viewType;
        elDelete.reasonCode = reason;
        elDelete.chargeItemIds = [...e].map((item: any) => item.id)
        if (haveLoginData(this.props.nickname)) {
            elDelete.deletedBy = this.props.nickname.employeeId
        }
        if (elDelete && elDelete.chargeItemIds.length > 0) {
            this.props.deleteChargeItemCBL(elDelete, target, Number(this.props.costAndRevenueId))
        }
    }
    private saveRevenue = (e: any[], target: string, shouldCleanStore: boolean) => {
        const chargeItems = [...e]
        // chargeItems = convertChildren(chargeItems)
        let opType = 'update'
        // create empty essoSplit
        const emptyExportJob = JSON.parse(JSON.stringify(CostRevSplitEmptyData))

        chargeItems.forEach((itemData: any) => {
            if (this.props.targetId === 1) {
                itemData.sourceType = 'Booking'
                itemData.bookingId = this.props.costAndRevenueId
            }
            if (this.props.targetId === 2) {
                itemData.sourceType = 'Equipment'
            }
            if (this.props.targetId === 3) {
                itemData.quantity = parseFloat(itemData.quantity)
                itemData.rate = parseFloat(itemData.rate.replace(/\,/g, ''))
                itemData.exchangeRate = parseFloat(itemData.exchangeRate)
                if (this.state.dialogData.type === 'edit') {
                    itemData.chargeItemId = itemData.id
                }
                itemData.children.forEach((child: IExportJob) => {
                    const distri = this.populateSaveObj(JSON.parse(JSON.stringify(emptyExportJob)), child)
                    if (distri !== null) {
                        itemData.essoRateDistributions.push(distri)
                    }
                })
            }
            if (this.props.targetId === 4) {
                itemData.sourceType = 'FCR'
            }
            if (this.props.targetId === 5) {
                itemData.sourceType = 'ETS'
            }
            // save cost/revenue
            if (itemData && !itemData.chargeItemId) {
                opType = 'add'
            }
            this.refactorSaveObj(itemData)
        })
        if (opType === 'add') {
            const key = target === CostColumnsData.TYPES.COST ? 'cblCostItems' : 'cblRevenueItems'
            const res: ISaveCostRevenue = {
                sourceId: '',
                insertBy: ''
            }
            res[key] = chargeItems
            res.insertBy = this.props.nickname.employeeId
            res.sourceId = this.props.costAndRevenueId.toString()

            this.callAPI(res, 'addCostAndRevenue', target)
            this.setState({
                pendingConfirmation: true,
                showDialog: false,
                errorMsg: '',
                isAddEditDialogExited: false
            })
        } else {
            // edit
            const key = target === CostColumnsData.TYPES.COST ? 'cblCostItems' : 'cblRevenueItems'
            const res: IEditCostRevenue = {
                sourceId: '',
                updatedBy: ''
            }
            res[key] = chargeItems
            res.updatedBy = this.props.nickname.employeeId
            res.sourceId = this.props.costAndRevenueId.toString()

            this.setState({
                footerUpdate: true,
                isAddEditDialogExited: false
            })
            this.callAPI(res, 'editCostAndRevenue', target)
        }
    }
    private refactorSaveObj = (chargeItem: IChargeItem) => {
        const extraFields: IChargeItemExtraFields = {
            children: [],
            errorReason: '',
            handleError: false,
            displayDistribution: false,
            totalLocalCurrency: '',
            total: '',
            delete: '',
            isSameParty: false,
            updateChildrenStatus: false,
            id: 0,
            party: '',
            partyDetails: '',
            icbIndicator: '',
            partyName: '',
            isOthers: false,
            others: '',
            itemType: ''
        }
        for (const key of Object.keys(extraFields)) {
            delete chargeItem[key]
        }
    }
    private populateSaveObj = (data: ICostRevenue, child: IExportJob) => {
        if (this.state.dialogData.type === 'add') {
            data.exportJobId = child.exportJobId
            delete data.essoRateDetailId
        }
        else {
            data.essoRateDetailId = child.essoRateDetailId
            delete data.exportJobId
        }
        data.rowVersion = child.rowVersion
        data.party = child.party
        data.partyDetails = child.partyDetails
        data.icbIndicator = child.icbIndicator ? child.icbIndicator : '-'

        data.quantityDistributions = []
        child.splits.forEach((split: IEquipments) => {
            if (this.state.dialogData.type === 'add') {
                if (split.select) {
                    const emptyObj = JSON.parse(JSON.stringify(EmptyQuantityDistribution))
                    emptyObj.bookingSplitId = split.bookingSplitId
                    delete emptyObj.essoRateDetailSplitId
                    data.quantityDistributions.push(emptyObj)
                }
            }
            else {
                if (split.select || split.select !== false) {
                    const emptyObj = JSON.parse(JSON.stringify(EmptyQuantityDistribution))
                    emptyObj.essoRateDetailSplitId = split.essoRateDetailSplitId
                    delete emptyObj.bookingSplitId
                    data.quantityDistributions.push(emptyObj)
                }
            }
        })
        if (data.quantityDistributions.length === 0) {
            return null
        }
        return data
    }
    private callAPI = (data: any, api: string, target: string) => {
        switch (api) {
            case 'addCostAndRevenue':
                this.props.saveCostAndRevenue({ ...data }, this.props.targetType, target)
                break
            case 'editCostAndRevenue':
                this.props.saveCostAndRevenue({ ...data }, this.props.targetType, target, true)
                break
        }
        this.props.eventCallback()
        this.setState({})
    }

    /**
     * Helper functions
     */

    private populateDataForEdit = (data: any[]) => {
        const editData: any[] = []
        data.forEach((d: any) => {
            const emtpyData = JSON.parse(JSON.stringify(CostRevNewEmptyData))
            emtpyData.id = d.id
            emtpyData.condCurrency = d.condCurrency
            emtpyData.exchangeRate = d.exchangeRate
            emtpyData.localCurrency = d.localCurrency
            emtpyData.materialCode = d.materialCode
            emtpyData.materialDescription = d.materialDescription
            emtpyData.quantity = d.quantity
            emtpyData.rate = d.rate
            emtpyData.unitOfMeasure = d.unitOfMeasure
            emtpyData.essoRateDistributions = []
            emtpyData.itemType = d.itemType
            emtpyData.passThrough = d.passThrough
            emtpyData.serviceRenderedAt = d.serviceRenderedAt
            emtpyData.vatPartner = d.vatPartner
            emtpyData.vatPartnerReasonCodeNo = ''
            editData.push({ ...emtpyData })
        })
        return editData
    }
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchDataLoading: state.costRevenue.isFetchDataLoading,
    isFetchDataError: state.costRevenue.isFetchDataError,
    pendingError: state.costRevenue.pendingError,
    feedbackResponse: state.costRevenue.newCode,
    nickname: state.nickname.userNickName,
    featureToggles: state.featureToggle.featureToggles,
    validateJobStatus: state.newCostRevenue.validateJobStatus,
    revenueResponse: state.costRevenue.revenueResponse,
    costResponse: state.costRevenue.costResponse
})

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    saveCostAndRevenue: (data: any, targetType: string, target: string, isEdit?: boolean) => dispatch(saveCostAndRevenue(data, targetType, target, isEdit)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    fetchJobStatus: (valueId: number) => dispatch(fetchJobStatus(valueId)),
    fetchRevenueData: (id: number, page?: number, pageSize?: number) => dispatch(fetchRevenueData(id, page, pageSize)),
    fetchCostData: (id: number, page?: number, pageSize?: number) => dispatch(fetchCostData(id, page, pageSize)),
    deleteChargeItemCBL: (chargeItems: any, type: string, id: number) => dispatch(deleteChargeItemCBL(chargeItems, type, id)),
})

export const CostAndRevenueNew = connect<IMapStateToProps, IMapDispatchToProps, unknown, IStore>(mapStateToProps, mapDispatchToProps)(_CostAndRevenueNew)